import { makeAutoObservable } from 'mobx';

export interface IStoreConfig {}

export function createStoreConfig() {
  return makeAutoObservable<IStoreConfig>({});
}

export type TStoreConfig = ReturnType<typeof createStoreConfig>;
